// extracted by mini-css-extract-plugin
export default {"container":"AppRootScreen_container__21zyA","toasts":"AppRootScreen_toasts__SrRo3","content":"AppRootScreen_content__oj6Sk","appWrapper":"AppRootScreen_appWrapper__n9Yn1"};